import React from 'react'
import _ from 'lodash'
import classNames from 'classnames'
import SwiperCore, { Navigation, Pagination, A11y, Autoplay, Lazy } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { STATIC_PATH, BASE_URL } from 'src/common/razzle-platform-components/configs'
import { joinPaths } from 'src/common/razzle-platform-components/utils'
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import './styles.css'


const svgPreloader = `
<svg width="120" height="100" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#fafafa" offset="20%" />
      <stop stop-color="#e0e0e0" offset="50%" />
      <stop stop-color="#fafafa" offset="70%" />
    </linearGradient>
  </defs>
  <rect width="120" height="100" fill="#fafafa" />
  <rect id="r" width="120" height="100" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-120" to="120" dur="1s" repeatCount="indefinite"  />
</svg>
`

const toBase64 = (str) =>
  typeof window === 'undefined'
    ? Buffer.from(str).toString('base64')
    : window.btoa(str)

SwiperCore.use([Navigation, Pagination, A11y, Autoplay, Lazy]);


const placeholderImage = `data:image/svg+xml;base64,${toBase64(svgPreloader)}`

const ImageSlider = ({ images, ...props }) => {
    return React.useMemo(() => (
        <div className="mini-swiper">
            <Swiper
                slidesPerView="auto"
                pagination={{ clickable: true }}
                autoHeight={true}
                navigation={true}
                lazy={true}
                preloadImages={false}
                watchSlidesVisibility={true}
            >
                {_.isEmpty(images) && (
                    <SwiperSlide>
                        <img src={joinPaths(STATIC_PATH, 'assets/images/item_background_for_map.png')} {...props} />
                    </SwiperSlide>
                )}
                {
                    images.map((image, index) => (
                        <SwiperSlide key={index}>
                            <img src={placeholderImage} data-src={joinPaths(BASE_URL, image.name['500x500'])} style={{ width: '100%' }} {...props} className={classNames(props.className, 'swiper-lazy')} loading={undefined} />
                        </SwiperSlide>
                    ))
                }
            </Swiper>
        </div>
    ), [images])
}

export default ImageSlider